"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _v = _interopRequireDefault(require("./agent-dashboard/v0"));

var _v2 = _interopRequireDefault(require("./agent-dashboard/v1"));

var _v3 = _interopRequireDefault(require("./agent-dashboard/v2"));

var _v4 = _interopRequireDefault(require("./agent-dashboard/v3"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'AgentDashboard',
  components: {
    V0: _v.default,
    V1: _v2.default,
    V2: _v3.default,
    V3: _v4.default
  },
  data: function data() {
    return {
      profile: {},
      user: {},
      labels: [],
      values: [],
      loadingUser: true,
      loadingProfile: true,
      numberOfDecimal: 2
    };
  },
  computed: {
    currentVersion: function currentVersion() {
      return "V".concat(this.$store.getters.platform);
    }
  },
  created: function created() {
    var _this = this;

    _httpUtils.default.post("agentCost", "getNumberOfDecimal", {}, null).then(function (res) {
      _this.numberOfDecimal = res.data.numberOfDecimal;
      console.log(_this.numberOfDecimal);
    }).catch(function (err) {
      _this.$message({
        message: err.message,
        type: 'error'
      });
    });

    _httpUtils.default.get("HomeData", "getAgentIndex").then(function (res) {
      _this.user = res.user;
      _this.loadingUser = false;
    });

    _httpUtils.default.get("HomeData", "sumOrgCodeInAgent").then(function (res) {
      _this.profile = res.data;
      _this.loadingProfile = false;
    });

    _httpUtils.default.get("HomeData", "getTopTenOrganizationWithHighestPaymentInAgent").then(function (res) {
      // Testing
      // res = [
      //   {
      //     organizationName: 'Organization A',
      //     total: 120
      //   },
      //   {
      //     organizationName: 'Organization B',
      //     total: 12
      //   },
      // ]
      res.data.forEach(function (data) {
        _this.labels.push(data.organizationName ? data.organizationName : data.organizationCode);

        _this.values.push(data.amount);
      });
      var labelLength = _this.labels.length;
      if (!labelLength) return;

      if (labelLength < 10) {
        for (var i = 0; i < 10 - labelLength; i++) {
          _this.labels.push('-');

          _this.values.push(0);
        }
      }

      if (_this.values.length) _this.$nextTick(function () {
        return _this.$refs.dashboard.$refs.barChart.initChart();
      });
    });
  }
};
exports.default = _default;